import { render, staticRenderFns } from "./showNoticeTable.vue?vue&type=template&id=5b37ace2&"
import script from "./showNoticeTable.vue?vue&type=script&lang=js&"
export * from "./showNoticeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b37ace2')) {
      api.createRecord('5b37ace2', component.options)
    } else {
      api.reload('5b37ace2', component.options)
    }
    module.hot.accept("./showNoticeTable.vue?vue&type=template&id=5b37ace2&", function () {
      api.rerender('5b37ace2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/noticeComponent/showNoticeTable.vue"
export default component.exports